import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

export async function fetchShareholderDividends() {
  const res = await fetch(`${API_BASE}/api/shareholder/dividends`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل بيانات الأرباح'));
  return {
    myOwnershipPct: Number(data.myOwnershipPct ?? 0),
    summary: {
      totalReceived: Number(data.summary?.totalReceived ?? 0),
      lastReceived: Number(data.summary?.lastReceived ?? 0),
      nextEstimated: Number(data.summary?.nextEstimated ?? 0),
      averageYieldPct: Number(data.summary?.averageYieldPct ?? 0),
    },
    records: Array.isArray(data.records) ? data.records : [],
  };
}
